<template>
  <div class="container">
    <div class="title">
      <span class="title-text">巡视状态</span>
      <span class="view-memo" @click="viewBackup">查看巡视备注<a-icon type="file-search" class="icon-view" :size="14"/></span>
    </div>
    <div class="inspecting-list">
      <a-tag color="#EEF2F6" class="tag"
        v-for="item in inspectingUserList"
        :key="item.adminUserId"
      >{{ item.realName }}巡视中</a-tag>
    </div>
    <div class="inspected-list scrollableBar">
      <template>
        <a-timeline :pending="recordListLoading">
          <a-timeline-item color="#5F60D3"
            v-for="item in inspectRecordList"
            :key="item.startTime"
          >
            <p>巡视课堂，{{ item.inspectorRealName }}，<span class="inspect-time">{{ item.startTime }}</span></p>
          </a-timeline-item>
        </a-timeline>
      </template>
    </div>
    <!-- 巡视备注弹窗 -->
    <BackupDialog
      :showDialog="showBackupDialog"
      :defaultBackup="inspectBackup"
      @setBackupDialog="setBackupDialog" />
  </div>
</template>

<script>
import BackupDialog from './BackupDialog'
import lodash from 'lodash'
import { LIVE_STATUS, INSPECT_STATUS } from '@/consts/live'

export default {
  name: 'InspectionStatus',
  props: {
    classroomDetail: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  components: {
    BackupDialog
  },
  data () {
    return {
      classroomCode: this.$route.query.classroomCode,
      showBackupDialog: false,
      recordListLoading: false,
      recordPageNum: 1,
      recordPageSize: 10,
      inspectBackup: '',
      inspectRecordList: [],
      inspectTotal: 0,
      updateInspectStateTimer: null,
      getInspectUserTimer: null,
      inspectingUserList: [],
      mainDom: null
    }
  },
  mounted() {
    this.searchInspectRecordByPage()
    this.inspectExtendInfo()
    const self = this
    self.mainDom = document.querySelector('.inspected-list')
    // 滚动到底分页加载
    self.mainDom.addEventListener('scroll', lodash.throttle(function (e) {
      console.log(self.mainDom.scrollHeight, self.mainDom.scrollTop,self.mainDom.clientHeight)
      if (self.mainDom.scrollHeight - self.mainDom.scrollTop <= self.mainDom.clientHeight + 50) {
        const { recordPageNum, recordPageSize, inspectTotal, recordListLoading } = self
        if (inspectTotal <= recordPageNum * recordPageSize || recordListLoading) return
        self.recordPageNum += 1
        self.searchInspectRecordByPage()
      }
    }, 400))

    window.addEventListener('beforeunload', () => {
      this.leavePage()
    })
  },
  beforeDestroy() {
    this.leavePage()
  },
  watch: {
    classroomDetail: {
      handler(nVal) {
        const { status } = nVal
        if (status === LIVE_STATUS.ING) { // 直播进行中
          if (this.getInspectUserTimer) clearInterval(this.getInspectUserTimer)
          if (this.updateInspectStateTimer) clearInterval(this.updateInspectStateTimer)

          this.inspectingUsers()
          this.createUpdateInspectRecord({type: INSPECT_STATUS.ING})
          this.getInspectUserTimer = setInterval(() => {
            this.inspectingUsers()
          }, 2000)
          this.updateInspectStateTimer = setInterval(() => {
            this.createUpdateInspectRecord({type: INSPECT_STATUS.ING})
          }, 10000)
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    leavePage() {
      this.mainDom.removeEventListener('scroll', () => {
        console.log('mainDom removeEventListener')
      })
      if (this.getInspectUserTimer) clearInterval(this.getInspectUserTimer)
      if (this.updateInspectStateTimer) clearInterval(this.updateInspectStateTimer)

      if (this.classroomDetail.status !== LIVE_STATUS.ING) return
      this.createUpdateInspectRecord({ type: INSPECT_STATUS.END })
    },
    // 巡查中的人
    async inspectingUsers() {
      const { classroomCode } = this
      const { liveId } = this.classroomDetail
      try {
        const res = await this.$http.inspectingUsers({
          classroomCode,
          liveId
        })
        if (res.code !== 200) return
        this.inspectingUserList = res.rt || []
      } catch (error) {

      }
    },
    // 上报是否巡查
    async createUpdateInspectRecord({ type }) {
      const { classroomCode } = this
      const { liveId } = this.classroomDetail
      try {
        const res = await this.$http.createUpdateInspectRecord({
          classroomCode,
          liveId,
          type // 1-开始巡视 2-结束巡视
        })
      } catch (error) {

      }
    },
    // 分页查询巡视记录列表
    async searchInspectRecordByPage() {
      this.recordListLoading = true
      const { classroomCode } = this
      const { recordPageNum, recordPageSize, inspectRecordList } = this
      try {
        const res = await this.$http.searchInspectRecordByPage({
          classroomCode,
          pageNum: recordPageNum,
          pageSize: recordPageSize
        })
        if (res.code !== 200) return
        const { ext, list, totalCount } = res.rt || {}
        this.inspectBackup = (ext || {}).notes || ''
        this.inspectRecordList = [...inspectRecordList, ...(list || [])]
        this.inspectTotal = totalCount
      } catch (error) {
        console.log('分页查询巡视记录列表error', error)
      }
      this.recordListLoading = false
    },
    // 分页查询巡视备注
    async inspectExtendInfo() {
      const { classroomCode } = this
      try {
        const res = await this.$http.inspectExtendInfo({
          classroomCode
        })
        if (res.code !== 200) return
        const { notes } = res.rt || {}
        this.inspectBackup = notes || ''
      } catch (error) {
        console.log('查询备注error', error)
      }
    },
    viewBackup() {
      this.showBackupDialog = true
      this.inspectExtendInfo()
    },
    setBackupDialog({ showBackupDialog }) {
      this.showBackupDialog = showBackupDialog
    }
  }
}
</script>

<style lang="scss" scoped>
  .container{
    color: #1E2228;
    .title {
      font-size: 14px;
      margin-bottom: 16px;
      .title-text{
        font-size: 14px;
        font-weight: bold;
        margin-right: 16px;
        &::before {
          content: '';
          display: inline-block;
          width:0;
          border: 1px solid #5F60D3;
          height: 12px;
          margin-right: 5px;
        }
      }
      .view-memo{
        color:#5F60D3;
        cursor: pointer;
        .icon-view{
          margin-left: 5px;
        }
        &:hover{
          font-weight: bold;
        }
      }
    }
    .inspecting-list{
      margin-bottom: 12px;
      .tag{
        color: #1E2228;
        margin-bottom: 10px;
      }
    }
    .inspected-list{
      padding-top: 2px;
      max-height: 314px;
      overflow: auto;
    }
    ::v-deep.ant-timeline-item{
      padding: 0 0 12px;
    }
  }
</style>